import "jquery";
import _, { filter } from "lodash";
import "./acreditaciones.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Acreditaciones";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/

let rounds_title = document.createElement("p");
rounds_title.innerText =
  "Selecciona una jornada y un equipo para ver sus acreditaciones.";

page_template_content.appendChild(rounds_title);

// for the season
let row = document.createElement("div");
row.classList.add("row");
row.style.marginBottom = "10px";

let col_season = document.createElement("div");
col_season.classList.add("col-sm-12", "col-md-4", "col-lg-4");
col_season.style.marginRight = "10px";

row.appendChild(col_season);
page_template_content.appendChild(row);

// for the rounds
// let row_rounds = document.createElement("div");
// row_rounds.classList.add("row");

let col_rounds = document.createElement("div");
col_rounds.classList.add("col-sm-12", "col-md-4", "col-lg-4");

row.appendChild(col_rounds);

// add filter button
// let row_filter = document.createElement("div");
// row_filter.classList.add("row");

let col_filter = document.createElement("div");
col_filter.classList.add("col-sm-12", "col-md-2", "col-lg-2");

row.appendChild(col_filter);

let filter_button = document.createElement("button");
filter_button.classList.add("btn", "btn-primary");
filter_button.style.height = "60%";
filter_button.style.marginTop = "10px";
filter_button.style.width = "100%";
filter_button.innerText = "Filtrar";
filter_button.style.minHeight = "40px";

col_filter.appendChild(filter_button);

// page_template_content.appendChild(row_rounds);

// loadSeason
loadSeason(col_season).then(() => {
  document.getElementById("id_season").addEventListener(
    "change",
    (e) => {
      document.getElementById("js__container_id_round").remove();
      document.getElementById("js__acreditaciones_list").innerHTML = "";

      loadRounds(col_rounds);
    },
    true
  );
});

// load rounds
loadRounds(col_rounds).then(() => {
  document.getElementById("id_round").addEventListener(
    "change",
    (e) => {
      let round_id = e.target.value;

      loadAcreditaciones(round_id);
    },
    true
  );
});

filter_button.addEventListener("click", (e) => {
  loadAcreditaciones(document.getElementById("id_round").value);
});

// list of acreditaciones
let row_list = document.createElement("div");
row_list.classList.add("row");
row_list.id = "js__acreditaciones_list";

let col_list = document.createElement("div");
col_list.classList.add("col-sm-12", "col-md-12", "col-lg-12");

// page_template_content.appendChild(row_filter);

page_template_content.appendChild(row_list);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/

async function loadSeason(container) {
  await getSeasons().then((result) => {
    let items = result.items;
    items.unshift({ name: "Seleccionar una temporada", id: 0 });
    container.appendChild(
      coffee_main.createOptionList(
        "Temporada",
        "id_season",
        "id_season",
        items.map((item) => {
          return { text: item.name, value: item.id };
        }),
        true
      )
    );
  });
}

async function loadRounds(container) {
  await getRounds().then((result) => {
    let items = result.items;
    items.unshift({ name: "Seleccionar una jornada", id: 0 });
    container.appendChild(
      coffee_main.createOptionList(
        "Jornada",
        "id_round",
        "id_round",
        items.map((item) => {
          return { text: item.name, value: item.id };
        }),
        true
      )
    );
  });
}

async function loadAcreditaciones(id_round) {
  let list = document.createElement("div");
  list.classList.add("row");

  // console.log("id_round", id_round);
  if (id_round != "0") {
    await getAcreditaciones(id_round).then((result) => {
      // console.log("result", result);
      result.items.forEach((item) => {
        let a_acreditacion = document.createElement("a");
        a_acreditacion.href =
          base_url + "/instance/acreditaciones/print/" + item.id;

        let row_acreditacion = document.createElement("div");
        row_acreditacion.classList.add("row", "row_acreditacion");

        let acreditaciones_team_1 = document.createElement("div");
        acreditaciones_team_1.classList.add("col-sm-3", "col-md-3", "col-lg-3");
        acreditaciones_team_1.innerText = "Equipo: " + item.team.name;

        let acreditaciones_vs = document.createElement("div");
        acreditaciones_vs.classList.add("col-sm-3", "col-md-3", "col-lg-3");
        acreditaciones_vs.innerText = "Datos del juego: ";

        let acreditaciones_team_2 = document.createElement("div");
        acreditaciones_team_2.classList.add("col-sm-3", "col-md-3", "col-lg-3");
        acreditaciones_team_2.innerText = item.game.name;

        let acreditaciones_number = document.createElement("div");
        acreditaciones_number.classList.add("col-sm-3", "col-md-3", "col-lg-3");
        acreditaciones_number.innerText = "#" + item.game.number;

        row_acreditacion.appendChild(acreditaciones_team_1);
        row_acreditacion.appendChild(acreditaciones_vs);
        row_acreditacion.appendChild(acreditaciones_team_2);
        row_acreditacion.appendChild(acreditaciones_number);

        a_acreditacion.appendChild(row_acreditacion);

        list.appendChild(a_acreditacion);
      });
    });
  } else {
    let no_acreditaciones = document.createElement("div");
    no_acreditaciones.classList.add("col-sm-12", "col-md-12", "col-lg-12");
    no_acreditaciones.innerText = "Seleccionar una Jornada.";

    list.appendChild(no_acreditaciones);
  }
  document.getElementById("js__acreditaciones_list").innerHTML = "";
  document.getElementById("js__acreditaciones_list").appendChild(list);
}

//ajax calls
async function getRounds() {
  let id_season = document.getElementById("id_season")
    ? document.getElementById("id_season").value
    : coffee_main.id_season;
  var ajax_data = {
    id_season: id_season
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/rounds/season",
    data: ajax_data
  });
}

//ajax calls
async function getSeasons() {
  var ajax_data = {};

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/seasons/all",
    data: ajax_data
  });
}

async function getAcreditaciones(id_round) {
  var ajax_data = {
    id_round: id_round,
    with: ["team", "game"]
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/instance/acreditaciones/all",
    data: ajax_data
  });
}

(() => {
  //add event listener
})();
